module.exports = __webpack_public_path__ + "img/face_2_1.54de64b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/face_2_1.png
// module id = ./assets/img/face_2_1.png
// module chunks = 9